import React from 'react'
import BillingLayout from 'components/layouts/BillingLayout'
import Path from 'routes/path'
import { getBillingLabel } from 'helper/getBillingLabel'

export function BillingEstimate(props) {
  const { reservation, company } = props.data
  const billing = reservation.billing
  const room = reservation.room
  const space = reservation.space
  const optionItems = reservation.reservedOptionItems.results
  const optionFoods = reservation.reservedOptionFoods.results

  let date
  if (billing.paidAt == null) {
    date = billing.updatedAtText
  } else {
    date = billing.paidAtText
  }

  return (
    <BillingLayout
      title={i18n.t('server.business.billing.title')}
      description={i18n.t('server.business.billing.description')}
      {...props}
    >
      <div id="wrapper">
        <div id="global_header">
          <div>
            <h1>
              <a href={Path.home()}>
                <img
                  alt="SPACEMARKET"
                  src="//cdnspacemarket.com/images/email/logo_business.png"
                />
              </a>
            </h1>
            <p className="date">領収日: {date}</p>
          </div>
        </div>
        <div id="main_contents">
          <h2>{getBillingLabel(reservation)}</h2>
          <div id="main_header">
            <div id="payee_info">
              <div>
                <h3>
                  {company.name}
                  <span>様</span>
                </h3>
                <dl className="total_payment schedule_to_pay">
                  <dt>金額</dt>
                  <dd className="price">
                    {billing.totalPayAmountForUserWithTaxText}-
                  </dd>
                </dl>
              </div>
            </div>
          </div>
          <div className="table payment_history">
            <div className="sub_header">
              <p className="id">
                <b>
                  明細 # {reservation.id}-{billing.id}
                </b>
              </p>
              <div>
                <dl className="room_name">
                  <dt>
                    {room.name} - {reservation.planName}
                  </dt>
                  <dd>
                    {room.name} / {space.name}
                  </dd>
                </dl>
                <dl className="date_rented">
                  <dt />
                </dl>
              </div>
            </div>
            <table className="space">
              <tbody>
                <tr>
                  <th className="name">品名</th>
                  <th className="price">単価</th>
                  <th className="number">個数</th>
                  <th className="profit">価格</th>
                </tr>
                <tr>
                  <td className="name">
                    {reservation.startedAtText || ''}スペース使用料
                  </td>
                  <td />
                  <td />
                  <td>{billing.roomAmountText}</td>
                </tr>

                {billing.extraGuestStayAmount > 0 && (
                  <tr>
                    <td className="name">人数超過料金</td>
                    <td />
                    <td />
                    <td>{billing.extraGuestStayAmountText}</td>
                  </tr>
                )}
                {billing.optionCleaningAmount > 0 && (
                  <tr>
                    <td className="name">管理維持費</td>
                    <td />
                    <td />
                    <td>{billing.optionCleaningAmountText}</td>
                  </tr>
                )}
                {optionItems.map(item => (
                  <tr key={item.id}>
                    <td className="name">{item.name}</td>
                    <td>{item.priceText}</td>
                    <td>{item.number}</td>
                    <td>{item.totalAmountText}</td>
                  </tr>
                ))}
                {optionFoods.map(food => (
                  <tr key={food.id}>
                    <td className="name">{food.name}</td>
                    <td>{food.priceText}</td>
                    <td>{food.number}</td>
                    <td>{food.totalAmountText}</td>
                  </tr>
                ))}
                {billing.changeAmount !== 0.0 && (
                  <tr>
                    <td className="name">
                      価格変更({billing.changeDescription})
                    </td>
                    <td />
                    <td />
                    <td>{billing.changeAmountText}</td>
                  </tr>
                )}
                {reservation.isLoyalCustomerDiscount && (
                  <tr>
                    <td className="name">お得意様割</td>
                    <td />
                    <td />
                    <td>
                      - {billing.loyalCustomerDiscountAmountExceptTaxText}
                    </td>
                  </tr>
                )}
                {reservation.isLastMinuteDiscount && (
                  <tr>
                    <td className="name">直前割</td>
                    <td />
                    <td />
                    <td>- {billing.lastMinuteDiscountAmountExceptTaxText}</td>
                  </tr>
                )}
                {billing.weeklyDiscountAmount > 0 && (
                  <tr>
                    <td className="name">週割</td>
                    <td />
                    <td />
                    <td>- {billing.weeklyDiscountAmountText}</td>
                  </tr>
                )}
                {billing.monthlyDiscountAmount > 0 && (
                  <tr>
                    <td className="name">月割</td>
                    <td />
                    <td />
                    <td>- {billing.monthlyDiscountAmountText}</td>
                  </tr>
                )}
                {billing.cancelFee > 0.0 && (
                  <tr>
                    <td className="name">キャンセル手数料</td>
                    <td />
                    <td />
                    <td>{billing.cancelFeeText}</td>
                  </tr>
                )}
                {billing.cancelFee === 0.0 && billing.guestFeeAmount > 0.0 && (
                  <tr>
                    <td className="name">サービス料</td>
                    <td />
                    <td />
                    <td>{billing.guestFeeAmountText}</td>
                  </tr>
                )}
                {billing.cancelFee === 0.0 &&
                  billing.guestPostpayFeeAmount > 0.0 && (
                    <tr>
                      <td className="name">後払い手数料</td>
                      <td />
                      <td />
                      <td>{billing.guestPostpayFeeAmountText}</td>
                    </tr>
                  )}
                {billing.isAppliedPoint && (
                  <tr>
                    <td className="name">ポイント割引</td>
                    <td />
                    <td />
                    <td>- {billing.pointDiscountAmountText}</td>
                  </tr>
                )}
                <tr>
                  <td className="name">消費税額</td>
                  <td />
                  <td />
                  <td>{billing.guestSalesTaxText}</td>
                </tr>
                {billing.guestTotalAmountWithTaxText !==
                  billing.totalPayAmountForUserWithTaxText &&
                  billing.isAppliedCoupon && (
                    <tr>
                      <td className="name">小計</td>
                      <td />
                      <td />
                      <td>{billing.guestTotalAmountWithTaxText}</td>
                    </tr>
                  )}
                {billing.cancelFee === 0.0 && billing.isAppliedCoupon && (
                  <tr>
                    <td className="name">クーポン割引</td>
                    <td />
                    <td />
                    <td>- {billing.discountAmountText}</td>
                  </tr>
                )}
              </tbody>
            </table>
            {billing.refundedAmount > 0.0 && (
              <tr>
                <td className="name">払い戻し金額</td>
                <td />
                <td />
                <td>- {billing.refundedAmountText}</td>
              </tr>
            )}
            <div className="sum">
              <p>
                <span>合計</span>
                {billing.totalPayAmountForUserWithTaxText}
              </p>
            </div>
          </div>
          <dl className="user_info">
            <dt>
              株式会社スペースマーケット
              <span />
            </dt>
            <dd>
              〒150-0001
              <br />
              渋谷区神宮前6-25-14
              <br />
              JRE神宮前メディアスクエアビル2F
              <br />
              03-6304-5618
            </dd>
            <img
              className="company_seal"
              src="//cdn.spacemarket.net/assets/print/company_seal-75b3bc1b53503154585a07af2419e421.jpg"
              alt="Company seal"
            />
          </dl>
        </div>
      </div>
    </BillingLayout>
  )
}
